export default class QuickSearchTracking {
    constructor(element, gtm) {
        this.gtm = gtm;
        this.$element = $(element);

        // we want to keep order
        this.channelElements = [
            this.$element.find('.js-channel')
        ];

        this.formElements = [
            this.$element.find('.js-maker'),
            this.$element.find('.js-model'),
            this.$element.find('.js-attr_price_max'),
            this.$element.find('.js-attr_m_year_min'),
            this.$element.find('.js-attr_m_km_max'),
            this.$element.find('.js-attr_m_fuel'),
            this.$element.find('.js-zipcode'),
            this.$element.find('.js-radius')
        ];
    }

    init() {
        this.$element
            .on('submit', $.proxy(this, 'trackEvent'))
            .on('submit', $.proxy(this, 'checkUsedChannel'));
    }

    getQuickSearchEventLabel() {
        const channelTracking = this.channelElements.map(el => this.getTrackingLabel(el, '&')).join('');
        const formTracking = this.formElements.map(el => this.getTrackingLabel(el, '')).join('|');
        return channelTracking + '|' + formTracking;
    }

    trackEvent() {
        this.gtm.trackEvent(this.$element.data('quicksearch-tracking'), this.getQuickSearchEventLabel());
    }

    checkUsedChannel() {
        const channelUsed = this.$element.find('#used');
        if($(channelUsed).is(':checked')) {
            $('input[name="attr_m_channel_used_i"]').prop('checked', true);
        } else {
            $('input[name="attr_m_channel_used_i"]').prop('checked', false);
        }
    }

    getTrackingLabel(element, joiner) {
        const selected = element.is('select,fieldset,div') ? element.find(':selected,:checked') : element;

        if(selected.length === 0) {
            return 'NULL';
        }

        return selected.map((index, val) => $(val).data('trackingLabel') || $(val).text() || $(val).val() || 'NULL')
            .toArray().join(joiner);
    }

}
